module.exports = __webpack_public_path__ + "static/customer-testimonial-bg-3-tablet-a76b8bd0edf727928d52be8ab04203b5.png";